import { selectors } from "../model/index.js";
const modifyReferences = (referencesState, references) => {
  for (const currentRef of references) {
    const referenceValue = selectors.selectById(referencesState, currentRef.id);
    if (!(referenceValue == null ? void 0 : referenceValue.data)) {
      continue;
    }
    const displayName = referenceValue.data.alternateName || referenceValue.data.name;
    Object.assign(currentRef, {
      ...referenceValue.data,
      displayName
    });
  }
};
export {
  modifyReferences
};
